import { FilterOption } from 'components/featured/Deals/types';
import { useCallback, useEffect, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

export const useBusinessOptions = () => {
  const [businessOptions, setBusinessOptions] = useState<FilterOption[]>([]);

  const fetchBusinesses = useCallback(async () => {
    try {
      const data = await BusinessesService.getBusinesses();
      const formattedData = data.businesses
        .map((item: any) => ({
          Name: item.name || '',
          Id: item.businessId || '',
        }))
        .filter((item: any) => item.Name && item.Id);
      setBusinessOptions(formattedData);
    } catch (error) {
      console.error('Failed to fetch clients', error);
      setBusinessOptions([]);
    } finally {
    }
  }, []);

  useEffect(() => {
    fetchBusinesses();
  }, [fetchBusinesses]);

  return {
    businessOptions,
  };
};
